import {type ReactNode, useCallback, useMemo} from "react";

import type {IGalleryImage} from "../types/IGalleryImage";
import {GalleryPicture} from "./GalleryPicture";
import {GalleryVideo} from "./GalleryVideo";

import * as styles from "./GalleryPicturesGrid.module.css";

interface IProps {
    getImageAlt: (index: number, isConstructionImage?: boolean) => string;
    images: IGalleryImage[];
    onImageClick: (index: number) => void;
    lastTile?: ReactNode;
    video?: string | null;
    shouldShowVideo?: boolean;
}

export const GalleryPicturesGrid = (props: IProps) => {
    const renderGalleryPicture = useCallback((index: number, image: IGalleryImage) => {
        return <GalleryPicture key={index} onClick={() => props.onImageClick(index)} {...image} />;
    }, []);

    const {video, shouldShowVideo} = props;

    const withVideo = video && shouldShowVideo;

    if (!props.images.length && !withVideo) {
        return null;
    }

    const {evenImages, oddImages} = useMemo(() => {
        const startIndex = withVideo ? 1 : 0;

        return props.images.reduce<{oddImages: IGalleryImage[]; evenImages: IGalleryImage[]}>(
            (acc, image, index) => {
                const imageWithAlt = {...image, imgAlt: props.getImageAlt(index)};
                const adjustedIndex = startIndex + index;

                adjustedIndex % 2 === 0 ? acc.evenImages.push(imageWithAlt) : acc.oddImages.push(imageWithAlt);
                return acc;
            },
            {evenImages: [], oddImages: []}
        );
    }, [props.images, withVideo]);

    // yes, this placement calculation is naive, but this feature is hot... if that bothers anyone, calculate combined images height or whatever
    const evenCount = evenImages.length + (withVideo ? 1 : 0);
    const oddCount = oddImages.length;
    const lastTilePlacement = evenCount > oddCount ? "odd" : "even";

    return (
        <div className={styles.galleryRow}>
            <div className={styles.galleryColumn}>
                {withVideo && <GalleryVideo url={video} />}
                {evenImages.map((image, index) => {
                    const imageIndex = withVideo ? index * 2 + 1 : index * 2;
                    return renderGalleryPicture(imageIndex, image);
                })}
                {lastTilePlacement === "even" && props.lastTile && <div>{props.lastTile}</div>}
            </div>

            <div className={styles.galleryColumn}>
                {oddImages.map((image, index) => {
                    const imageIndex = withVideo ? index * 2 : index * 2 + 1;
                    return renderGalleryPicture(imageIndex, image);
                })}
                {lastTilePlacement === "odd" && props.lastTile && <div>{props.lastTile}</div>}
            </div>
        </div>
    );
};
import {type ReactNode, useCallback, useMemo} from "react";

import type {IGalleryImage} from "../types/IGalleryImage";
import {GalleryPicture} from "./GalleryPicture";
import {GalleryVideo} from "./GalleryVideo";

import * as styles from "./GalleryPicturesGrid.module.css";

interface IProps {
    getImageAlt: (index: number, isConstructionImage?: boolean) => string;
    images: IGalleryImage[];
    onImageClick: (index: number) => void;
    lastTile?: ReactNode;
    video?: string | null;
    shouldShowVideo?: boolean;
}

export const GalleryPicturesGrid = (props: IProps) => {
    const renderGalleryPicture = useCallback((index: number, image: IGalleryImage) => {
        return <GalleryPicture key={index} onClick={() => props.onImageClick(index)} {...image} />;
    }, []);

    const {video, shouldShowVideo} = props;

    const withVideo = video && shouldShowVideo;

    if (!props.images.length && !withVideo) {
        return null;
    }

    const {evenImages, oddImages} = useMemo(() => {
        const startIndex = withVideo ? 1 : 0;

        return props.images.reduce<{oddImages: IGalleryImage[]; evenImages: IGalleryImage[]}>(
            (acc, image, index) => {
                const imageWithAlt = {...image, imgAlt: props.getImageAlt(index)};
                const adjustedIndex = startIndex + index;

                adjustedIndex % 2 === 0 ? acc.evenImages.push(imageWithAlt) : acc.oddImages.push(imageWithAlt);
                return acc;
            },
            {evenImages: [], oddImages: []}
        );
    }, [props.images, withVideo]);

    // yes, this placement calculation is naive, but this feature is hot... if that bothers anyone, calculate combined images height or whatever
    const evenCount = evenImages.length + (withVideo ? 1 : 0);
    const oddCount = oddImages.length;
    const lastTilePlacement = evenCount > oddCount ? "odd" : "even";

    return (
        <div className={styles.galleryRow}>
            <div className={styles.galleryColumn}>
                {withVideo && <GalleryVideo url={video} />}
                {evenImages.map((image, index) => {
                    const imageIndex = withVideo ? index * 2 + 1 : index * 2;
                    return renderGalleryPicture(imageIndex, image);
                })}
                {lastTilePlacement === "even" && props.lastTile && <div>{props.lastTile}</div>}
            </div>

            <div className={styles.galleryColumn}>
                {oddImages.map((image, index) => {
                    const imageIndex = withVideo ? index * 2 : index * 2 + 1;
                    return renderGalleryPicture(imageIndex, image);
                })}
                {lastTilePlacement === "odd" && props.lastTile && <div>{props.lastTile}</div>}
            </div>
        </div>
    );
};
